import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable, catchError, of } from 'rxjs';
import { PQRMultiplicadorAnualDto } from '../../dtos/pqr-multiplicador-anual.dto';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../'
import { MemoriaDeCalculoRequestDto } from '../../dtos/memoria-calculo-dto'


@Injectable({
  providedIn: 'root',
})
export class PQRMultiplicadorAnualService {

  private apiUrl = `${environment.apiUrl}/pqr`;
  private apiUrlRest = `${environment.apiUrl}/pqr-multiplicador-anual`;

  constructor(
    private caqRequestService: CaqRequestService
  ) { }

  buscarListaDePQRMultiplicadorAnual(): Observable<PQRMultiplicadorAnualDto[]> {
    return this.caqRequestService
      .get<MemoriaDeCalculoRequestDto>(this.apiUrl)
      .pipe(
        map((response) => {
          try {
            return response.pqrMultiplicadorAnualList || [];
          } catch (error) {
            console.warn('Erro ao processar dados PQR Multiplicador Anual:', error);
            return [];
          }
        }),
        catchError((error) => {
          console.warn('Erro na requisição PQR Multiplicador Anual:', error);
          return of([]);
        })
      );
  }

  salvePQRMultiplicadorAnual(requisicao: PQRMultiplicadorAnualDto) {
    return firstValueFrom(this.caqRequestService
      .put<PQRMultiplicadorAnualDto>(`${this.apiUrlRest}/${requisicao.codPqrMultiplicadorAnual}`, requisicao)
      .pipe(map((response) => response)));
  }
}
